import React from 'react';
import { ProfilePhotoImage, ProfilePhotoPlaceholder } from './ProfilePictureUpload.styles';

/**
 * Circular avatar showing the student's profile photo, or a camera-icon
 * placeholder when none has been uploaded yet.
 */
function ProfilePhoto({ photoUrl, size = '42px' }) {
    if (photoUrl) {
        return <ProfilePhotoImage src={photoUrl} alt="" $size={size} />;
    }

    return (
        <ProfilePhotoPlaceholder $size={size}>
            <i className="fal fa-camera"></i>
        </ProfilePhotoPlaceholder>
    );
}

export default ProfilePhoto;
